import { render, staticRenderFns } from "./Patrol4mView.vue?vue&type=template&id=63061778&scoped=true&"
import script from "./Patrol4mView.vue?vue&type=script&lang=js&"
export * from "./Patrol4mView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63061778",
  null
  
)

export default component.exports